import React, { useEffect, useState } from 'react'
import UserService, { IUserModel } from '../../services/user'
import { Button } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { useDispatch } from 'react-redux'
import { updateSingleUser, updateUser } from './userSlice'
import { handleRequestError } from '../../services/api'
import Register2FA from '../auth/Register2FA'
import AuthService from '../auth/AuthService'
import { error } from 'console'

interface IProps {
    user: IUserModel
}

export default function Enable2FAButton(props: IProps) {

    const dispatch = useDispatch()

    const { user } = props
    const [enabled, setEnabled] = useState<boolean>(false)
    const [disable, setDisable] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (disable){

            setLoading(true)
            AuthService.disable2FA()
                .then(response => {

                    const message = response.data.message ? response.data.message : "Done!"

                    updateQuickNotificationDetails(true, message, "success", dispatch)

                    dispatch(updateUser({
                        ...user,
                        totp_enabled: false
                    }))
                    setLoading(false)
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                    setLoading(false)
                })

        }
    }, [disable])

    if (enabled){
        return(
            <div className="profile-page-register-2fa">
                <div className="content-of-profile-page-register-2fa">
                    <Register2FA />
                </div>
            </div>
        )
    }
    
    return <LoadingButton loading={loading} onClick={() => user.totp_enabled ? setDisable(true) : setEnabled(true)} className="general-button admin-style light-button" variant="contained" color={user.totp_enabled ? "error" : "success"} >{user.totp_enabled ? "Disable Two-Factor Authentication" : "Enable Two-Factor Authentication"}</LoadingButton>
}